import styled from "styled-components";
import { Colors } from "@smartsuite/types";

export const SuccessWrapper = styled.div`
  display: flex;
  padding: 10px 15px;
  margin-bottom: 20px;
  background-color: ${Colors.dwGreen};
  border-radius: 6px;
  border: 1px solid ${Colors.dwGreen};
  border-left: 3px solid ${Colors.bGreen};
  gap: 14px;
`;

export const ErrorWrapper = styled(SuccessWrapper)`
  background-color: ${Colors.dwRed};
  border: 1px solid ${Colors.dwRed};
  border-left: 3px solid ${Colors.bRed};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const SubTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
`;
